module.exports = __webpack_public_path__ + "img/mobile-partners.3fd45283.png";